<template>
    <div :class="['editable-cell', background ? 'bg' : 'none']">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number style="width: 100%" :step="step" :autoFocus="true" :max="max" class="text" :min="min" size="small" v-model="val" @blur="blur" @pressEnter="e => e.target.blur()" :precision='precision||precision==0 ? precision : 3' />
        </div>
        <div class="editable-cell-text-wrapper" :class="color"  @click="edit" v-else>
          <a-spin :spinning="loading" size="small" class="spinning-block">
            <!-- <span :class="color">
              {{ text === '' || text === null || text === undefined ? text : Number(text || 0).toFixed(len)}}
            </span> -->

            <span :class="color">
              {{ text === '' || text === null || text === undefined ? text : Number(text || 0).toFixed(len)}}
            </span>
          </a-spin>
        </div>
        <a-tooltip v-if="warningIcon && !editable">
          <template slot="title">
            最小值 > 最大值
          </template>
          <a-icon class="warningStyle" type="close-circle" theme="twoTone" two-tone-color="#ff0000" />
        </a-tooltip>
    </div>
</template>

<script>
export default {
  props:['text','item', 'name', 'actions','background','len','precision','isMix','attMax','attMin','constraintOptions'],
  data(){
    return {
      val:undefined,
      target:null,
      editable:false,
      loading:false,
      isBlue:false,
      isEdit: false
    }
  },
  computed:{
    color(){
      const {item,name,text} = this
      const {content,percentage,maxLimitValue,minLimitValue,maxValue,minValue,mixPercentage} = item
      let contentVal = content === '' || content === null ? content : Number(content).toFixed(this.len)
      const val =  text === '' || text === null ? text : Number(text).toFixed(this.len)
      if(this.isMix){
        if(this.constraintOptions === 'supplementary') {
          contentVal = percentage === '' || percentage === null ? percentage : Number(percentage).toFixed(this.len)
        }else{
          contentVal = mixPercentage === '' || mixPercentage === null ? mixPercentage : Number(mixPercentage).toFixed(this.len)
        }
      }
      const red = (val === contentVal || val === percentage) && (
        (name === 'maxLimitValue' && maxLimitValue !== '') ||
        (name === 'maxValue' && maxValue !== '')
        )
      const green = (val === contentVal || val === percentage) && ((name === 'minValue' && minValue !== '') || (name === 'minLimitValue' && minLimitValue !== ''))
      return {
        red,green,redBg:red,greenBg:green,blue: this.isEdit
      }
    },

    min(){
      return this.name === 'price' ? 0 : -999999999
    },
    max(){
      return this.name === 'price' ? 999999999999.999 : 999999999
    },

    defaultText(){
      const textValue = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len)
      return textValue
    },
    step(){
      const num = [1,0.1,0.01,0.001,0.0001]
      return num[this.len]
    },
    unit(){
      return this.len
    },
    // step(){
    //   // const normalUnit = this.item.rawName ? 0.001 : 0.01
    //   const normalUnit = this.item.rawName ? 0.0001 : 0.0001
    //   let units = normalUnit
    //   units = this.item.unit === 'Kcal' || this.item.unit === 'MJ' && ( this.name ==='minLimitValue' || this.name === 'maxLimitValue' || this.name === 'maxValue' || this.name === 'minValue' || this.name === 'content')
    //   ? 0 : normalUnit
    //   if(this.name === 'price') units = 0.001
    //   return units
    // },

    // nuit(){
    //   // const normalUnit = this.item.rawName ? 3 : 2
    //   const normalUnit = this.item.rawName ? 4 : 4
    //   let units = normalUnit
    //   units = this.item.unit === 'Kcal' || this.item.unit === 'MJ' && ( this.name ==='minLimitValue' || this.name === 'maxLimitValue' || this.name === 'maxValue' || this.name === 'minValue' || this.name === 'content')
    //   ? 0 : normalUnit
    //   if(this.name === 'price') units = 3
    //   return units
    // },
    warningIcon(){
      let flag = false
      if(this.name == 'minValue' || this.name == 'maxValue') {
        if((this.item.minValue || this.item.minValue === 0) && (this.item.maxValue || this.item.maxValue === 0) && (Number(this.item.minValue) > Number(this.item.maxValue))){
          flag = true
        }
      }
      return flag
    },
  },
  methods:{
    // nuits(){
    //   const normalUnit = this.item.rawName ? 4 : 4
    //   let units = normalUnit
    //   units = this.item.unit === 'Kcal' || this.item.unit === 'MJ' && ( this.name ==='minLimitValue' || this.name === 'maxLimitValue' || this.name === 'maxValue' || this.name === 'minValue' || this.name === 'content')
    //   ? 0 : normalUnit
    //   if(this.name === 'price') units = 3
    //   return units
    // },
    blur(e){
      this.editable = false
      let target = {...this.item}
      let val = e.target.value
      if(this.text === val || (this.text === Number(val) && val !== '') || (this.text === null && val === '')) return
      if(this.checkValue(this.val)){
        if(this.val < 0 && this.name === 'price'){
          this.$message.warn('价格不能为负数')
        }
        // 最值约束数值必须≥0，最小值或最大值 < 0 时默认更新为0
        if((this.name === 'minValue' || this.name === 'maxValue') && this.val !== null && Number(this.val) < 0){
          this.val = 0
        }
        this.isBlue=true
        target[this.name] = this.val ? Number(this.val).toFixed(this.len) : this.val
        this.target = target
        this.$nextTick(()=>{
          this.updates()
        })
      }
    },
    checkValue(val){
      const {name,item} = this
      if(val === null){
        return true
      } else if((name==="minLimitValue" && val > item.maxLimitValue && (item.maxLimitValue || item.maxLimitValue === 0))
      || (name==="maxLimitValue" && item.minLimitValue > val) 
      || (name==="maxValue" && item.minValue > val) 
      || (name==="minValue" && val > item.maxValue && (item.maxValue || item.maxValue === 0))) {
        // this.errorMessage()
        return true
      } else {
        return true
      }
    },
    async updates(){
      this.$nextTick(async() => {
        if(this.actions){
          this.loading = true
          await this.actions(this.target,true)
          this.loading = false
          this.$emit('blur',this.target)
        } else {
          this.loading = false
          this.$emit('blur',this.target)
        }
      })
    },
    change(val){
      this.val = val
    },
    edit(){
      if(this.item.isRawDelete != 1){
        this.editable = true
        this.isEdit = true
        this.val = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len)
      }
    },
    errorMessage(){
      const msg = this.name ==='minLimitValue' || this.name === 'maxLimitValue' ? '极下限不能大于极上限' :'最小值不能大于最大值'
      this.$message.warn(msg)
    }
  }
  }
</script>
